"use client";

import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustBullets = [{
  text: "30-minute strategy call"
}, {
  text: "Zero-pressure consultation"
}, {
  text: "Actionable recommendations"
}];
export default function StrategyCall() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section data-section-id="31007" id="ctastrategycall" ref={ref} className="relative overflow-hidden bg-background py-24 md:py-32 border-t border-[var(--accent-deep-red)]/30">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,hsl(352_54%_33%_/_0.15),transparent_70%)]" aria-hidden="true" />

      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <div className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-6 inline-flex items-center gap-2 rounded-lg border border-[var(--accent-deep-red)]/40 bg-[var(--accent-deep-red)]/10 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-[var(--accent-deep-red)]">
            <span className="relative flex size-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-[var(--accent-deep-red)] opacity-75"></span>
              <span className="relative inline-flex size-2 rounded-lg bg-[var(--accent-deep-red)]"></span>
            </span>
            <span>{"Take The Next Step"}</span>
          </div>

          <h2 style={{
          fontSize: "clamp(2.25rem, 5vw, 3.75rem)"
        }} className="font-default leading-tight tracking-tight text-foreground font-bold">
            {"Ready to turn your website into your "}
            <span className="italic text-[var(--accent-deep-red)] font-serif">
              {"best salesperson?"}
            </span>
          </h2>

          <p className="mt-6 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            {"Claim your free 30-minute strategy call and technical walkthrough. Learn exactly how to optimize your digital presence for maximum AI search visibility and lead generation."}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <div className="relative group w-full sm:w-auto">
              <div className="absolute -inset-0.5 rounded-lg bg-[var(--accent-deep-red)] opacity-75 blur-sm transition duration-500 group-hover:opacity-100 animate-pulse" />
              <Button asChild size="lg" className="relative w-full sm:w-auto bg-[var(--accent-deep-red)] text-white hover:bg-[var(--accent-deep-red)]/90 px-8 py-6 text-base font-semibold shadow-lg">
                <Link className="inline-flex items-center justify-center gap-2" to="/PricingPlansPage">
                  <span>Get started now</span>
                  <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            <Link className="relative py-2 text-base font-medium text-foreground transition-colors hover:text-[var(--accent-deep-red)] after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-[var(--accent-deep-red)] after:transition-all after:duration-300 hover:after:w-full" to="/ContactPage">
              {"Get a free AI visibility checkup"}
            </Link>
          </div>

          <Separator className="my-10 bg-border/60 max-w-md mx-auto" />

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {trustBullets.map((bullet, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
                <div className="flex size-5 items-center justify-center rounded-lg bg-[var(--accent-deep-red)]/15 text-[var(--accent-deep-red)]">
                  <Check className="size-3.5 stroke-[3]" />
                </div>
                <span>{bullet.text}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}